import { useState } from "react";

const useDrawerVisibility = <T extends Record<string, any>>(
  initialState = false,
  disableCondition?: (data: T) => boolean
) => {
  const [isVisible, setIsVisible] = useState(initialState);

  const open = () => setIsVisible(true);

  const close = () => setIsVisible(false);

  const toggle = () => setIsVisible((prev) => !prev);

  return {
    isVisible,
    open,
    close,
    toggle,
    isDisabled: disableCondition,
  };
};

export default useDrawerVisibility;
